export default "__VITE_ASSET__BxHl9KKc__"